import { ACCESS_TOKEN, AUTH, EXPIRED_SESSION, MESSAGE, USER_SESSION } from '../assets/constants';

function errorResponseHandler(error) {
    if (error.response) {
        if (error.response.status === 401) {
            // if (localStorage.getItem(AUTH) === null) {
            //     localStorage.setItem(MESSAGE, 'Favor de verificar sus credenciales e intentar nuevamente');
            // } else {
            if (localStorage.getItem(AUTH) === '1') {
                localStorage.clear();
                localStorage.setItem(MESSAGE, 'Su sesión ha expirado. Favor de ingresar nuevamente');
                window.location.reload();
            } else {
                // localStorage.setItem(MESSAGE, 'Favor de verificar sus credenciales e intentar nuevamente');
            }
        } else if (error.response.status === 404) {
            localStorage.setItem(MESSAGE, 'Ha ocurrido un problema consultado la información deseado. Favor de intentar más tarde');
        } else if (error.response.data) {
            localStorage.setItem(MESSAGE, error.response.data.message);
        } else {
            localStorage.setItem(MESSAGE, 'Ha ocurrido un problema desconocido. Favor de comunicarse con nosotros por correo electrónico.');
        }
    }
    return Promise.reject(error);
}
// //
export default errorResponseHandler;
